<app-container [noPadding]="handsetService.isMobile" fxLayoutAlign="center"
               [maxWidth]="handsetService.isNotMobile ? '552px': '100%'  "
               ngClass.lt-md="xs">
  <ng-container *ngIf="payment ; else loader">

    <app-card [title]="'Twój koszyk'"
              [sidePaddings]="handsetService.isMobile ? '28px' : '48px'">
      <div content fxLayoutGap="16px">
        <app-payment-method-summary
          style="display: none"
          [redirectCode]="redirectCodes.LIABILITIES"
          [form]="form"
          [redirectUrl]="PAY_URL"
          [payment]="payment"
          [addCardRedirectUrl]="'/creditCards/add'"
          [addCardReturnUrl]="PAY_URL + payment?.id"
          [paymentResultUrl]="PAY_URL + payment?.id"
          (expressPaymentChanged)="expressPaymentChanged($event)"
          (forcePaymentRefresh)="refreshPayment$.next(!refreshPayment$.value)"
          (errorEvent)="setError($event)"
          (submitButtonLoadingEvent)="onSubmitButtonLoadingEvent($event)"
        ></app-payment-method-summary>

        <app-payment-summary style="margin-right: 0"
                             [startedPayment]="startedDeferment"
                             *ngIf="payment; else loader"
                             [payment]="payment"
                             [paymentType]="payment?.type"
                             [emptyCartCouponId]="emptyCartCouponId$ | async"
                             [paymentMethodSelected]="form.methodSelected"
                             [enableRedirectToFragment]="true"
                             [paymentUrl]="PAY_URL"
                             [cancelPaymentRedirectUrl]="CANCEL_PAYMENT_URL"
                             [errorMsg]="error"

        >
        </app-payment-summary>
      </div>

      <div buttons fxLayout="column" fxFlex="center center" class="items-center" fxLayoutGap="16px">
        <ng-container *ngIf="startedDeferment; else paymentButtons">
          <app-new-loader-button
            (buttonClick)="onGoToDeferment()"
            [customType]="LoaderButtonType.RAISED"
            class="big-button button-250 self-center"
            color="accent">
            Wróć do opłacania
          </app-new-loader-button>
        </ng-container>
        <ng-template #paymentButtons>
          <p *ngIf="disabled">{{ disabledReason }}</p>
          <app-new-loader-button
            (buttonClick)="submit(payment)"
            [disabled]="!payment.id || !form.methodSelected || loading || disabled"
            [loading]="loading"
            [customType]="LoaderButtonType.RAISED"
            class="big-button button-250 self-center"
            color="accent">
            Odrocz
          </app-new-loader-button>
        </ng-template>
        <button
          *ngIf="payment"
          [disabled]="!payment.id"
          mat-button
          (click)="cancelPayment(payment.id)"
          class="font-medium button-250">
          Wyczyść koszyk
        </button>
      </div>

    </app-card>
  </ng-container>

</app-container>

<form>
  <input type="hidden" />
</form>
<router-outlet></router-outlet>

<ng-template #loader>
  <mat-card class="card" fxLayout="column" ngClass.xs="xs">
    <mat-card-content>
      <div style="transform: translateY(calc(-50% - 106px));">
        <app-loading></app-loading>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
